import template from './adpDropdown.html';
import controller from './adpDropdown.controller';
import './adpDropdown.less';

let adpDropdownComponent = {
  restrict: 'E',
  bindings: {
    userName: "@",
    profilePicLink: "@",
  },
  template,
  transclude: {
    popup: '?popupContent',
  },
  controller
};

export default adpDropdownComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpDropdown/adpDropdown.component.js